// extracted by mini-css-extract-plugin
module.exports = {"section":"services-module--section--1pVk0","body":"services-module--body--39F6w","article":"services-module--article--1-jIs","figcaption":"services-module--figcaption--lUHei"};